/* Winkelwagen bijwerken zonder de pagina te verlaten.

   De knoppen in de winkelwagen zijn gewone links naar /cart/change. Zonder
   JavaScript werkt dat, maar je verliest je plek: Shopify stuurt je na de
   wijziging ergens anders heen, en bij het weghalen van het laatste product
   beland je op een andere pagina dan waar je stond.

   Dit script vangt de klik af, doet dezelfde wijziging via /cart/change.js en
   tekent alleen de winkelwagen opnieuw. Het leest de regel en het aantal uit
   de href van de link, zodat er maar één plek is waar die logica staat: haalt
   het script het niet, dan doet de link precies hetzelfde.

   Werkt zowel op de winkelwagenpagina als in het zijpaneel — beide dragen
   data-cart-section met hun eigen sectie-id. */

(function () {
  'use strict';

  var teksten = window.ncStrings || {};
  var routes = (window.ncSettings && window.ncSettings.routes) || {};
  var bezig = false;

  function paramUit(href, naam) {
    try {
      return new URL(href, window.location.origin).searchParams.get(naam);
    } catch (e) {
      return null;
    }
  }

  /* De secties opnieuw ophalen via de Section Rendering API. Dat geeft precies
     dezelfde HTML als een volledige pagina, dus prijzen, de voortgangsbalk en
     de lege staat kloppen zonder dat dit script ze zelf hoeft na te rekenen.

     Álle winkelwagensecties, niet alleen die waarin je klikte: op de
     winkelwagenpagina staat het zijpaneel er ook, en dat bleef anders de
     verwijderde regel tonen tot je de pagina herlaadde. */
  function ververs() {
    var vakken = [].slice.call(document.querySelectorAll('[data-cart-section]'));
    var ids = vakken.map(function (v) { return v.dataset.cartSection; }).filter(Boolean);
    if (!ids.length) return Promise.resolve();

    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        vakken.forEach(function (vak) {
          var id = vak.dataset.cartSection;
          if (!data[id]) return;
          var nieuw = new DOMParser().parseFromString(data[id], 'text/html');
          var bron = nieuw.querySelector('[data-cart-section="' + id + '"]');
          if (bron) vak.innerHTML = bron.innerHTML;
        });
      });
  }

  /* De teller in de kop staat al in theme.js; hier alleen aanroepen, anders
     staan er twee plekken die hetzelfde doen en lopen ze ooit uiteen. */
  function tellers() {
    if (window.ncCart && window.ncCart.tellerBijwerken) {
      return window.ncCart.tellerBijwerken();
    }
    return Promise.resolve();
  }

  /* Kortingscode meteen toepassen.

     Via /cart/update.js met "discount": dat is de veilige weg. Nagemeten op
     deze winkel: een foute code laat de regels staan en komt terug met
     applicable: false. (/discount/CODE blijft verboden: die leegt bij een
     typefout de hele winkelwagen.)

     Het veld "discount" is de complete lijst die de wagen moet krijgen, geen
     toevoeging. Daarom eerst de codes die er al op staan ophalen en de nieuwe
     erbij zetten. Werkt de nieuwe niet, dan gaat de oude lijst terug, zodat er
     geen dode code blijft hangen die bij het afrekenen een foutmelding geeft. */
  function melding(tekst, soort) {
    var el = document.querySelector('[data-korting-melding]');
    if (!el) return;
    el.textContent = tekst;
    if (soort) el.setAttribute('data-soort', soort); else el.removeAttribute('data-soort');
  }

  function zetCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('update');
      return r.json();
    });
  }

  function toepassen(blok) {
    var veld = blok.querySelector('.cart__korting-veld');
    var knop = blok.querySelector('[data-korting-toepassen]');
    var code = (veld.value || '').trim();
    var t = blok.dataset;
    if (!code) { melding(t.tekstLeeg, 'fout'); veld.focus(); return; }
    if (bezig) return;

    bezig = true;
    knop.setAttribute('aria-busy', 'true');
    knop.disabled = true;
    var gelijk = function (a) { return a.code.toUpperCase() === code.toUpperCase(); };
    var oud = [];
    var uitkomst = 'fout';

    fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (kar) {
        oud = (kar.discount_codes || []).filter(function (c) { return c.applicable; });
        if (oud.some(gelijk)) { uitkomst = 'dubbel'; return null; }
        return zetCodes(oud.map(function (c) { return c.code; }).concat([code]));
      })
      .then(function (kar) {
        if (!kar) return null;
        var nieuw = (kar.discount_codes || []).filter(gelijk)[0];
        if (nieuw && nieuw.applicable) {
          uitkomst = 'gelukt';
          // Valt een eerdere code af omdat ze niet samen mogen, dan die er ook af.
          var blijft = kar.discount_codes.filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
          if (blijft.length !== kar.discount_codes.length) return zetCodes(blijft);
          return null;
        }
        return zetCodes(oud.map(function (c) { return c.code; }));
      })
      .then(function () { return Promise.all([ververs(), tellers()]); })
      .catch(function () { uitkomst = 'storing'; })
      .then(function () {
        bezig = false;
        // ververs() heeft het blok vervangen; de nieuwe knop en het veld opzoeken.
        var nieuwVeld = document.querySelector('.cart__korting-veld');
        var nieuweKnop = document.querySelector('[data-korting-toepassen]');
        if (nieuweKnop) { nieuweKnop.disabled = false; nieuweKnop.removeAttribute('aria-busy'); }
        if (uitkomst === 'gelukt') {
          melding(t.tekstGelukt.replace('__CODE__', code.toUpperCase()), 'gelukt');
        } else {
          if (nieuwVeld) { nieuwVeld.value = code; nieuwVeld.focus(); }
          melding(uitkomst === 'dubbel' ? t.tekstDubbel : uitkomst === 'storing' ? (teksten.cartError || t.tekstFout) : t.tekstFout, 'fout');
        }
      });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-korting-toepassen]');
    if (!knop) return;
    var blok = knop.closest('[data-korting]');
    if (!blok) return;
    e.preventDefault();
    toepassen(blok);
  });

  // Enter in het veld: toepassen, niet afrekenen.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('.cart__korting-veld')) return;
    var blok = e.target.closest('[data-korting]');
    if (!blok) return;
    e.preventDefault();
    toepassen(blok);
  });

  /* Iets toegevoegd vanuit de aanraders? Dan hoort de wagen mee te veranderen.
     Tijdens onze eigen wijziging niet: die ververst zichzelf al. */
  document.addEventListener('nc:cart:updated', function () {
    if (bezig) return;
    if (!document.querySelector('[data-cart-section]')) return;
    ververs();
  });

  /* Kortingscode weghalen. De link werkt op zichzelf al — hij laadt /cart
     opnieuw — maar dan spring je naar boven en ben je je plek kwijt. Hier
     wordt hij afgevangen zodat alleen de winkelwagen opnieuw getekend wordt. */
  document.addEventListener('click', function (e) {
    var weg = e.target.closest('[data-korting-weg]');
    if (!weg || !weg.href || bezig) return;

    e.preventDefault();
    bezig = true;
    var vak = weg.closest('[data-cart-section]');
    if (vak) vak.classList.add('is-bezig');

    fetch(weg.href, { credentials: 'same-origin' })
      .then(function () { return Promise.all([ververs(), tellers()]); })
      .catch(function () { window.location.href = weg.href; })
      .then(function () {
        bezig = false;
        document.querySelectorAll('[data-cart-section]').forEach(function (v) {
          v.classList.remove('is-bezig');
        });
      });
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cart__qty-button, .cart__item-remove');
    if (!link || !link.href) return;

    var vak = link.closest('[data-cart-section]');
    if (!vak) return;

    var regel = paramUit(link.href, 'line');
    var aantal = paramUit(link.href, 'quantity');
    if (regel === null || aantal === null) return; // geen wijzigingslink: laat de browser gaan

    e.preventDefault();
    if (bezig) return;
    bezig = true;

    /* Alleen de regel waar je op klikt reageert. Eerder werd het hele paneel
       gedimd; dan vervaagt bij het weghalen van één product de complete
       winkelwagen, inclusief wat er blijft staan, en dat leest als een storing.

       Weghalen krijgt een andere behandeling dan een aantal wijzigen: het een
       verdwijnt, het ander wacht even. Vind ik de regel niet — een knop buiten
       een regel, of markup die verandert — dan alsnog het paneel, want zonder
       enige terugkoppeling lijkt een klik niet aangekomen. */
    var regelEl = link.closest('.cart__item');
    if (regelEl) {
      regelEl.classList.add(Number(aantal) === 0 ? 'is-weg' : 'is-wacht');
    } else {
      vak.classList.add('is-bezig');
    }

    fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(regel), quantity: Number(aantal) })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(teksten.cartError || 'Er ging iets mis.');
        return Promise.all([ververs(), tellers()]);
      })
      .catch(function () {
        // Lukt het niet, dan alsnog langs de gewone weg: beter een sprong naar
        // een andere pagina dan een knop die niets doet.
        window.location.href = link.href;
      })
      .then(function () {
        bezig = false;
        // De regel zelf is met de nieuwe lijst meegekomen en bestaat niet meer;
        // het paneel opruimen kan geen kwaad als het er niet op stond.
        vak.classList.remove('is-bezig');
      });
  });
})();
